// eslint-disable-next-line import/extensions
const { version } = require('./package.json')

const config = {
  PORT: process.env.PORT || 3001,
  'process.env.NODE_ENV': process.env.NODE_ENV,
  COOKIE_KEYS: {
    LANGUAGE: 'mfpLocale',
    CSRF_TOKEN: 'csrfToken',
    ACCESS_TOKEN: 'access_token', // Must remain for compatibility with all current sessions
    REFRESH_TOKEN: 'refresh_token', // Must remain for compatibility with all current sessions
    JSESSIONID: 'JSESSIONID' // Must remain for legacy
  }
}

config.MCHAPP_VERSION = version

module.exports = config
